import Icon from '../components/Icon.vue'

Icon.register({
  splotch: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M472.3 195.9c48.5 16.6 53.8 73.8 9 96.8l-62 31.7c-17.8 9.1-29.3 25.2-30.6 43l-4.7 61.9c-3.4 44.8-65.1 66.8-104.5 37.2l-54.3-40.8c-15.6-11.7-37-16.1-57.1-11.7l-70 15.3c-50.7 11.1-94.1-32.6-73.5-73.8l28.4-57c8.2-16.4 6.4-35.2-4.6-50.2l-38.5-52.4c-27.9-38 7-86.9 59-82.8l71.9 5.6c20.7 1.6 40.9-5.6 54.2-19.3l46.1-47.7c33.4-34.5 98.4-21.2 110 22.6l16 60.4c4.6 17.4 18.9 31.7 38.1 38.3z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/splotch.js
// module id = 1938
// module chunks = 0